import { ISpotBase } from '../../models/spots';
import jhsfBookingsApi from '../apis/jhsfBookingsApi';

interface ICreateSpotProps {
  description?: string;
  isActive: boolean;
  isLivingArea: boolean;
  name: string;
  ventureId: string;
}

export type INewSpot = ISpotBase;

export const createSpotsService = async ({
  description,
  isActive,
  isLivingArea,
  name,
  ventureId,
}: ICreateSpotProps): Promise<INewSpot> => {
  const { data } = await jhsfBookingsApi.post<INewSpot>('/spots', {
    description,
    isActive,
    isLivingArea,
    name,
    ventureId,
  });

  return data;
};
